
import React, { useState } from "react";
import { Menu } from "lucide-react";
import { NavLink, Outlet } from "react-router-dom";

export default function AdminLayout({ children }) {
  const [open, setOpen] = useState(false);

  return (
    <div className="min-h-screen bg-ekine-grayLight">
      <div className="flex">
        {/* SIDEBAR - El navbar debe ser fijo en todo momento para mantener la compensación del margen. */}
        {/* Eliminamos 'md:static' para que siga siendo fijo y se mantenga fuera del flujo, 
            permitiendo que 'md:ml-64' en el CONTENIDO haga su trabajo correctamente. */}
        <aside
          className={`
            fixed inset-y-0 left-0 z-40
            w-64 bg-[#0b2052] text-white
            transform transition-transform duration-200 ease-out
            ${open ? "translate-x-0" : "-translate-x-full"}
            md:translate-x-0 
          `}
        >
          {/* Logo + título */}
          <div className="px-4 py-4 border-b border-white/10">
            <div className="text-2xl font-bold">EKINE</div>
            <div className="text-sm text-blue-100">Administrador</div>
          </div>

          {/* Navegación */}
          <nav className="mt-4 space-y-1 px-2 pb-6">
            <NavItem to="/admin/agenda" label="Agenda" setOpen={setOpen} />
            <NavItem to="/admin/dashboard" label="Tablero de Control" setOpen={setOpen} />
            <NavItem to="/admin/pacientes" label="Pacientes" setOpen={setOpen} />
            <NavItem to="/admin/faq" label="Preguntas Frecuentes" setOpen={setOpen} />
            <NavItem to="/admin/roles" label="Roles" setOpen={setOpen} />
            <NavItem to="/admin/cupones" label="Cupones" setOpen={setOpen} />
            <NavItem to="/admin/editarsitio" label="Editar Sitio" setOpen={setOpen} />
            <NavItem to="/admin/desempeno-trabajadores" label="Desempeño Trabajadores" setOpen={setOpen} />
          </nav>
        </aside>

        {/* OVERLAY en mobile */}
        {open && (
          <div
            className="fixed inset-0 bg-black/40 z-30 md:hidden"
            onClick={() => setOpen(false)}
          />
        )}

        {/* CONTENIDO - Usa md:ml-64 para crear el espacio para el sidebar fijo. */}
        {/* Para el móvil (donde el sidebar está fuera de pantalla), he añadido 'w-full' para asegurar el ancho completo. */}
        <div className="flex-1 w-full min-h-screen md:ml-64">
          

          {/* Contenido de las páginas de admin */}
          <main className="p-4 md:p-6">
            {/* Si usan children directos, se muestran; si usan rutas anidadas, se usa Outlet */}
            {children || <Outlet />}
          </main>
        </div>
      </div>
    </div>
  );
}

function NavItem({ to, label, setOpen }) {
  return (
    <NavLink
      to={to}
      end
      onClick={() => setOpen(false)} // cerrar menú en móvil
      className={({ isActive }) =>
        `
        block w-full text-left px-4 py-2 rounded-xl
        text-sm font-medium transition-colors
        ${isActive
          ? "bg-[#2455ff] text-white"
          : "text-blue-100 hover:bg-blue-700/70"}
        `
      }
    >
      {label}
    </NavLink>
  );
}